export default function contentWysiwyg () {
  const $ = require('jquery')
  $(document).ready(function () {
    $('.content-wysiwyg table').each(function () {
      if ($(this).parent().hasClass('table-responsive') === false) {
        $(this).wrap('<div class="table-responsive"></div>')
      }
      if ($(this).hasClass('table') === false) {
        $(this).addClass('table')
      }
      $(this).find('thead').addClass('thead-light')
    })
  })
}
